import {GET_EVENTS_CYCLE_START} from "../../types";

export const events_cycle = (payload) => ({
  type: GET_EVENTS_CYCLE_START,
  payload,
});
